import classNames from 'classnames';

import { thousandSeparated } from 'shared/util/formatting';
import { SearchResultsSortDropdown } from '../searchResultsSortDropdown/SearchResultsSortDropdown';
import type { Filters, MapConfig, SearchConfig } from '@/interfaces';
import { trackMapClick } from '@/utils/tracking/finnAnalytics';
import { updateSearchResultsPageQueryParams } from '@/utils/url/routerHelpers';

export interface TopBarMobileProps {
    numberOfHotels: number;
    mapOpen: boolean;
    setMapState: (config: MapConfig) => void;
    filtersOpen: boolean;
    setFiltersOpen: (filtersOpen: boolean) => void;
    filters: Filters;
    searchConfig: SearchConfig;
}

export const TopBarMobile = ({
    numberOfHotels,
    mapOpen,
    setMapState,
    filtersOpen,
    setFiltersOpen,
    filters,
    searchConfig,
}: TopBarMobileProps) => {
    const mapClick = () => {
        setMapState({ open: !mapOpen, selectedHotel: {} });
        updateSearchResultsPageQueryParams(!mapOpen, filters, searchConfig);
        trackMapClick(!mapOpen);
    };
    return (
        <div className="grid u-hide-gt768 ">
            <div className="topbar-level2 u-pt8">
                {filtersOpen ? (
                    <div className="top-bar-button" />
                ) : (
                    <button
                        type="button"
                        className="button button--small button--utility top-bar-button"
                        onClick={mapClick}
                        data-testid="showMapButton">
                        <i
                            className={classNames('icon u-mr8', { 'icon--pin': !mapOpen, 'icon--cross-mini': mapOpen })}
                            style={{ width: '16px', height: '16px' }}
                        />
                        {mapOpen ? 'Lukk kart' : 'Vis kart'}
                    </button>
                )}
                <output className="u-strong" data-testid="resultCount">
                    {numberOfHotels ? thousandSeparated(numberOfHotels) : '0'}
                </output>
                <button
                    type="button"
                    className={`button button--small top-bar-button ${filtersOpen ? 'button--cta' : 'button--utility'}`}
                    onClick={() => setFiltersOpen(!filtersOpen)}
                    data-testid="showFilterButton">
                    {filtersOpen ? 'Vis resultat' : 'Vis filter'}
                </button>
            </div>
            {!mapOpen && (
                <div className="u-size1of1 u-float-right u-pt8">
                    <SearchResultsSortDropdown id="sortDropdownMobile" horizontal />
                </div>
            )}
        </div>
    );
};
